import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function SeoNotFound() {
  return (
    <div className="pt-40 pb-24 min-h-screen text-center">
      <Seo title="Page not found | ROOM XIII" description="This page could not be found." path="/404" noindex />
      <h1 className="font-display text-4xl">Page not found</h1>
      <Link to="/" className="text-gold mt-6 inline-block">Back to home</Link>
    </div>
  );
}
